import { render, staticRenderFns } from "./quotation_share_details.vue?vue&type=template&id=d1be383c&scoped=true&"
import script from "./quotation_share_details.vue?vue&type=script&lang=js&"
export * from "./quotation_share_details.vue?vue&type=script&lang=js&"
import style0 from "./quotation_share_details.vue?vue&type=style&index=0&id=d1be383c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1be383c",
  null
  
)

export default component.exports